export const delayUnits = ['Weeks', 'Days', 'Hours', 'Minutes'] as const;
export type DelayUnits = typeof delayUnits[number];

const aMinute = 60 * 1000;
const anHour = 60 * aMinute;
const aDay = 24 * anHour;
const aWeek = 7 * aDay;

const durations: { [key in DelayUnits]: number } = {
  Weeks: aWeek,
  Days: aDay,
  Hours: anHour,
  Minutes: aMinute,
};

export interface HowManyAndUnits {
  howMany: number;
  units: DelayUnits;
}

export const getDefault = (): HowManyAndUnits => ({
  howMany: 0,
  units: 'Minutes',
});

export const getHowManyAndUnits = (howMany: number, units: DelayUnits): HowManyAndUnits => ({
  howMany: howMany,
  units: units,
});

const getIfDivisible = (timeInMillis: number, units: DelayUnits): HowManyAndUnits | null =>
  timeInMillis % durations[units] === 0 ? getHowManyAndUnits(timeInMillis / durations[units], units) : null;

export const getInitialValues = (timeInMillis: number): HowManyAndUnits => {
  if (timeInMillis === 0) {
    return getDefault();
  }
  const values = delayUnits.map(x => getIfDivisible(timeInMillis, x as DelayUnits)).filter(x => x !== null);
  return values[0] ? values[0] : getDefault();
};

export const getDelay = (howMany: number, unit: string) => howMany * durations[unit];
